import { httpRequest } from '@common/util/api-common.util';
import { showAlerta} from '@common/common.action';

export const EXIBIR_MODAL_LIBERACAO_TOTAL = 'EXIBIR_MODAL_LIBERACAO_TOTAL';
export const exibirModal = (event) => ({
  type: EXIBIR_MODAL_LIBERACAO_TOTAL,
  payload: true,
});

export const CONFIRMAR_LIBERACAO_TOTAL = 'CONFIRMAR_LIBERACAO_TOTAL';
export const liberarLaudoTotalmente = () => {

  return (dispatch, getState) => {
    const state = getState();
    const listaLaudos = [];
    listaLaudos.push(+state.modalLiberacaoParcial.laudo);
    const usuarioLogado = state.usuario.usuarioId;

    httpRequest(
      `laudos/liberacao-total`,
      'POST',
      {
        usuarioLogado: usuarioLogado,
        Laudos: listaLaudos
      }
    ).then(resp => dispatch([{ type: CONFIRMAR_LIBERACAO_TOTAL, payload: listaLaudos.at(0) }, showAlerta('sucesso','Laudo liberado com sucesso',2000)]));
  }
};



// WEBPACK FOOTER //
// ./src/pages/laudo/modais/liberacao_total/store/liberacaoTotal.action.js